import { PROJECT_PICKER_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { PROJECT_FIELD_GQL_TYPE } from '../constants';
import type { JiraProjectField } from '../fragment/types';
import type { TransformedProjectField } from '../types';
import type { ProjectTransformersMapping } from './types';

export const transformProjectField = (): ProjectTransformersMapping => ({
	[PROJECT_FIELD_GQL_TYPE]: (field: JiraProjectField): TransformedProjectField | null => {
		if (field.__typename !== PROJECT_FIELD_GQL_TYPE) {
			return null;
		}

		return {
			type: PROJECT_PICKER_CF_TYPE,
			fieldId: field.fieldId,
			name: field.name,
			value: field.project
				? {
						id: field.project.id,
						name: field.project.name ?? '',
						key: field.project.key ?? '',
						avatarUrls: { '48x48': field.project.avatar?.large ?? '' },
					}
				: null,
		};
	},
});
